{
  "nav": {
    "dashboard": "Tableau de bord",
    "articles": "Articles",
    "authors": "Auteurs",
    "media": "Médias",
    "analytics": "Statistiques",
    "settings": "Paramètres",
    "logout": "Déconnexion"
  },
  "articles": {
    "title": "Articles",
    "newArticle": "Nouvel article",
    "editArticle": "Modifier l'article",
    "drafts": "Brouillons",
    "inReview": "En révision",
    "published": "Publiés",
    "archived": "Archivés",
    "status": "Statut",
    "category": "Catégorie",
    "language": "Langue",
    "author": "Auteur",
    "updated": "Mis à jour",
    "actions": "Actions",
    "noArticles": "Aucun article pour le moment",
    "deleteConfirm": "Êtes-vous sûr de vouloir supprimer cet article ?"
  },
  "editor": {
    "step1": "Titre & Slug",
    "step2": "Contenu",
    "step3": "Médias",
    "step4": "Badges & Métadonnées",
    "step5": "Accès & Dons",
    "step6": "Révision & Publication",
    "saveDraft": "Enregistrer le brouillon",
    "submitReview": "Soumettre à la révision",
    "publish": "Publier",
    "archive": "Archiver",
    "requestChanges": "Demander des modifications",
    "approve": "Approuver",
    "step5AccessLabel": "Niveau d'accès",
    "step5AccessDesc": "Tous les articles sont gratuits et accessibles à tous les lecteurs en v1. Le contenu à accès limité ou réservé aux abonnés n'est pas encore disponible.",
    "step5DonationLabel": "Soutien des lecteurs",
    "step5DonationDesc": "Les lecteurs soutiennent Beyond Silence via Buy Me a Coffee. Un lien de don apparaît à la fin de chaque article publié. Aucun abonnement ni paywall n'est requis."
  },
  "dashboard": {
    "title": "Tableau de bord",
    "publishedCount": "Articles publiés",
    "totalViews": "Vues totales",
    "totalDonations": "Dons totaux",
    "avgReadTime": "Temps de lecture moyen",
    "topArticles": "Articles populaires",
    "topAuthors": "Auteurs populaires",
    "dateRange": "Période",
    "filter": "Filtrer"
  }
}
